import * as Sentry from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

Sentry.init({
    dsn: "https://a5bf7fe2e4258793fc82e0171f5879e2@o4504784736813056.ingest.us.sentry.io/4507830076964864",
    // 100%トレースはイベント自体のクォータ枯渇リスクがあるため引き下げる。
    // エラーのサンプリングはデフォルト(100%)のまま変更しない。
    tracesSampleRate: 0.1,
    // 未設定だとローカル開発ビルドでもイベントを送信してしまっていたため明示する。
    enabled: import.meta.env.MODE === "production",
    // vite.config.ts の define でビルド時に埋め込まれた値（サーバー側と同じ
    // VERCEL_ENV）。preview/production を区別するために使う。
    environment: process.env.VERCEL_ENV ?? "development",
    // admin/fitness/medical の3アプリが同一 DSN を共有しているため、
    // どのアプリのイベントかを区別できるようタグ付けする。
    initialScope: { tags: { app: "medical" } },

    integrations: [Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches
    })]
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});